import React, {Fragment} from 'react'
import {Link} from 'react-router-dom'

import withSlider from '../hoc/with-slider'

import FavoriteHeart from '../favorite-heart'

const ProductListCard = ({brand, page, id, price, oldPrice, title, index,
                           isViewedArrow, handleArrowClick, updateSliderBackgrounds}) => {

  return (
    <Link className="item-list__item-card item" to={`/${page}/${id}`}>
      <div className="item-pic"
           style={updateSliderBackgrounds(index)}>
        <div/>
        <FavoriteHeart id={id}>
          {(handleClick, classNameEnd) =>
            <div className={`product-catalogue__product_favorite${classNameEnd}`}
                 onClick={handleClick}>
              <p/>
            </div>
          }
        </FavoriteHeart>
        {isViewedArrow && (
          <Fragment>
            <div className="arrow arrow_left" onClick={handleArrowClick}/>
            < div className="arrow arrow_right" onClick={handleArrowClick}/>
          </Fragment>
        )}
      </div>
      <div className="item-desc">
        <h4 className="item-name">{title}</h4>
        <p className="item-producer">Производитель: <span className="producer">{brand}</span></p>
        <p className="item-price">{price.toLocaleString('ru-RU')}</p>
        {oldPrice && <p className="item-price old-price">{oldPrice.toLocaleString('ru-RU')}</p>}
      </div>
    </Link>
  )
};

export default withSlider(ProductListCard)
